import { Button } from '@cdl/heartbeat-react';

type Props = {
  clearAllData: () => void;
  label?: string;
};

export const ClearButton: React.FC<Props> = ({
  clearAllData,
  label = 'Clear',
}) => {
  return (
    <Button
      as='a'
      size='m'
      variant='quaternary'
      color='red.400'
      display='flex'
      justifyContent='flex-end'
      onClick={clearAllData}
      mt='l'
    >
      {label}
    </Button>
  );
};
